Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TwitterContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.TwitterContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    return socialContent.data and socialContent.data.type == 'twitter' and socialContent.group_type == 'datasift'
